import { render, staticRenderFns } from "./SegmentsCreate.vue?vue&type=template&id=983d4bb0&scoped=true"
import script from "./SegmentsCreate.vue?vue&type=script&lang=ts"
export * from "./SegmentsCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983d4bb0",
  null
  
)

export default component.exports